/**
 * Constantes de roles de usuario (única fuente de verdad).
 * Usado en lista de usuarios, filtros, formularios y badges.
 */

export type UserRole = 'owner' | 'manager' | 'employee' | 'cashier';

export const ROLE_ORDER: UserRole[] = ['owner', 'manager', 'employee', 'cashier'];

export const ROLE_OPTIONS: { label: string; value: UserRole }[] = [
  { label: 'Propietario', value: 'owner' },
  { label: 'Gerente', value: 'manager' },
  { label: 'Empleado', value: 'employee' },
  { label: 'Cajero', value: 'cashier' },
];

/** Opciones con value primero (para ChoiceList/filtros que usan value/label). */
export const ROLE_CHOICE_OPTIONS = ROLE_OPTIONS.map((o) => ({ value: o.value, label: o.label }));

/** Mapeo valor → etiqueta para badges y columnas. */
export const ROLE_LABEL_MAP: Record<UserRole, string> = Object.fromEntries(
  ROLE_OPTIONS.map((o) => [o.value, o.label])
) as Record<UserRole, string>;

/** Tono del badge por rol (Polaris). */
export function getRoleBadgeTone(role: UserRole): 'success' | 'info' | 'attention' | undefined {
  if (role === 'owner') return 'success';
  if (role === 'manager') return 'info';
  if (role === 'cashier') return 'attention';
  return undefined;
}
